import { createResponsiveImageStyles } from '../../../utils/imageHelpers';

const ResponsiveImage = ({
  imagePath,
  altText,
  responsiveImageStyle,
  damImage,
  caption,
  credit,
  className = '',
  imageMaxHeight,
  setHeight,
  urlWebp,
  lazySrcAttr = false,
}) => {
  const responsiveImages = createResponsiveImageStyles(
    responsiveImageStyle,
    imagePath,
    damImage,
    urlWebp,
  );

  if (!responsiveImages) {
    return '';
  }

  const fallback = responsiveImages.find((item) => typeof item === 'string');
  const sources = responsiveImages
    .map((source) => {
      if (typeof source === 'object') {
        if (lazySrcAttr) {
          source['data-srcset'] = source.srcSet;
          delete source.srcSet;
          return <source key={source['data-srcset']} {...source} />;
        }
        return <source key={source.srcSet} {...source} />;
      }
      return '';
    })
    .reverse();

  let renderCaption = caption || '';
  renderCaption = credit ? `${renderCaption} ${credit}` : renderCaption;

  return (
    <>
      <picture className={className}>
        {sources}
        <img
          src={lazySrcAttr ? '' : fallback}
          data-src={lazySrcAttr ? fallback : ''}
          alt={altText}
          style={{
            maxHeight: imageMaxHeight ? `${imageMaxHeight}px` : '',
            height: setHeight && imageMaxHeight ? `${imageMaxHeight}px` : '',
          }}
          loading="lazy"
        />
      </picture>
      {(caption || credit) && (
        <div
          className="image--description image--credit"
          dangerouslySetInnerHTML={{ __html: renderCaption }}
        />
      )}
    </>
  );
};

export default ResponsiveImage;
